import rowCard from "../../custom/rowCard/rowCard.vue";
import calculationDetail from "../calculationDetail/calculationDetail.vue";

import columnRowCard from "../../custom/rowCard/columnRowCard";
import * as STYLE from "../../custom/rowCard/styleRowCard";

import {
  BASKET_TYPE_HOTEL,
  BASKET_TYPE_TRANSFER,
  BASKET_TYPE_TRAIN,
  BASKET_TYPE_EXCURSION,
  UNIT_VOLUME_MBN,
  UNIT_VOLUME_PLA,
  UNIT_VOLUME_NUM,
  UNIT_VOLUME_DAY,
  UNIT_VOLUME_NGT,
  UNIT_VOLUME_SRV,
  UNIT_VOLUME_MAN,
  UNIT_VOLUME_HOR,
  UNIT_VOLUME_SRP,
  UNIT_VOLUME_SRM,
  UNIT_VOLUME_SMH
} from "../../../util/enumTypes";

import dateUtil from "../../../util/dateUtil";
import util from "../../../util/util";

export default {
  components: {
    rowCard,
    calculationDetail
  },
  props: {
    basket: {
      type: Object,
      required: true
    }
  },
  computed: {
    hotelTitle() {
      let result = [];

      let column = new columnRowCard(
        "sequence",
        this.$t("calculation_table_num")
      );
      column.setColumnStyle(
        "3%",
        STYLE.STYLE_COLUMN_TITLE_CENTER,
        STYLE.STYLE_CENTER
      );
      result.push(column);

      column = new columnRowCard("cityName", this.$t("calculation_table_city"));
      column.setColumnStyle(
        "12%",
        STYLE.STYLE_COLUMN_TITLE_LEFT,
        STYLE.STYLE_LEFT
      );
      result.push(column);

      column = new columnRowCard(
        "hotelName",
        this.$t("calculation_table_hotel")
      );
      column.setColumnStyle(
        "17%",
        STYLE.STYLE_COLUMN_TITLE_LEFT,
        STYLE.STYLE_LEFT
      );
      result.push(column);

      column = new columnRowCard(
        "description",
        this.$t("calculation_table_description")
      );
      column.setColumnStyle(
        "32%",
        STYLE.STYLE_COLUMN_TITLE_LEFT,
        STYLE.STYLE_LEFT
      );
      result.push(column);

      column = new columnRowCard(
        "quantity",
        this.$t("calculation_table_quantity")
      );
      column.setColumnStyle(
        "5%",
        STYLE.STYLE_COLUMN_TITLE_CENTER,
        STYLE.STYLE_CENTER
      );
      result.push(column);

      column = new columnRowCard("night", this.$t("calculation_table_nights"));
      column.setColumnStyle(
        "5%",
        STYLE.STYLE_COLUMN_TITLE_CENTER,
        STYLE.STYLE_CENTER
      );
      result.push(column);

      column = new columnRowCard("date", this.$t("calculation_table_dates"));
      column.setColumnStyle(
        "14%",
        STYLE.STYLE_COLUMN_TITLE_CENTER,
        STYLE.STYLE_CENTER
      );
      result.push(column);

      column = new columnRowCard("price", this.$t("calculation_table_price"));
      column.setColumnStyle(
        "5%",
        STYLE.STYLE_COLUMN_TITLE_CENTER,
        STYLE.STYLE_COLUMN_DATA_RIGHT_MONEY
      );
      result.push(column);

      column = new columnRowCard("guid", "", "action");
      column.setColumnStyle(
        "6%",
        STYLE.STYLE_COLUMN_TITLE_CENTER,
        STYLE.STYLE_CENTER
      );
      result.push(column);

      return result;
    },
    transferTitle() {
      let result = [];

      let column = new columnRowCard(
        "sequence",
        this.$t("calculation_table_num")
      );
      column.setColumnStyle(
        "5%",
        STYLE.STYLE_COLUMN_TITLE_CENTER,
        STYLE.STYLE_CENTER
      );
      result.push(column);

      column = new columnRowCard("cityName", this.$t("calculation_table_city"));
      column.setColumnStyle(
        "15%",
        STYLE.STYLE_COLUMN_TITLE_LEFT,
        STYLE.STYLE_LEFT
      );
      result.push(column);

      column = new columnRowCard(
        "description",
        this.$t("calculation_table_description")
      );
      column.setColumnStyle(
        "45%",
        STYLE.STYLE_COLUMN_TITLE_LEFT,
        STYLE.STYLE_LEFT
      );
      result.push(column);

      column = new columnRowCard(
        "quantity",
        this.$t("calculation_table_quantity")
      );
      column.setColumnStyle(
        "10%",
        STYLE.STYLE_COLUMN_TITLE_CENTER,
        STYLE.STYLE_CENTER
      );
      result.push(column);

      column = new columnRowCard("date", this.$t("calculation_table_dates"));
      column.setColumnStyle(
        "15%",
        STYLE.STYLE_COLUMN_TITLE_CENTER,
        STYLE.STYLE_CENTER
      );
      result.push(column);

      column = new columnRowCard("price", this.$t("calculation_table_price"));
      column.setColumnStyle(
        "10%",
        STYLE.STYLE_COLUMN_TITLE_CENTER,
        STYLE.STYLE_COLUMN_DATA_RIGHT_MONEY
      );
      result.push(column);

      return result;
    },
    excursionTitle() {
      let result = [];

      let column = new columnRowCard(
        "sequence",
        this.$t("calculation_table_num")
      );
      column.setColumnStyle(
        "5%",
        STYLE.STYLE_COLUMN_TITLE_CENTER,
        STYLE.STYLE_CENTER
      );
      result.push(column);

      column = new columnRowCard("cityName", this.$t("calculation_table_city"));
      column.setColumnStyle(
        "20%",
        STYLE.STYLE_COLUMN_TITLE_LEFT,
        STYLE.STYLE_LEFT
      );
      result.push(column);

      column = new columnRowCard(
        "description",
        this.$t("calculation_table_description")
      );
      column.setColumnStyle(
        "43%",
        STYLE.STYLE_COLUMN_TITLE_LEFT,
        STYLE.STYLE_LEFT
      );
      result.push(column);

      column = new columnRowCard(
        "quantity",
        this.$t("calculation_table_quantity")
      );
      column.setColumnStyle(
        "10%",
        STYLE.STYLE_COLUMN_TITLE_CENTER,
        STYLE.STYLE_CENTER
      );
      result.push(column);

      column = new columnRowCard("date", this.$t("calculation_table_dates"));
      column.setColumnStyle(
        "15%",
        STYLE.STYLE_COLUMN_TITLE_CENTER,
        STYLE.STYLE_CENTER
      );
      result.push(column);

      column = new columnRowCard("price", this.$t("calculation_table_price"));
      column.setColumnStyle(
        "7%",
        STYLE.STYLE_COLUMN_TITLE_CENTER,
        STYLE.STYLE_COLUMN_DATA_RIGHT_MONEY
      );
      result.push(column);

      return result;
    },
    requestList() {
      // Элементы под запрос, ж/д и экскурсии
      let result = [];
      let sq = 1;

      this.basket.requestItems.forEach(item => {
        if (item.type == BASKET_TYPE_TRAIN) {
          result = result.concat(this.trainBasket2Calculation(item, sq));
        } else if (item.type == BASKET_TYPE_EXCURSION) {
          result = result.concat(this.excursionBasket2Calculation(item, sq));
        }

        sq++;
      });

      return result;
    },
    totalHotelPrice() {
      return (
        util.formatMoney(this.totalHotel) +
        " " +
        this.$store.getters.SignCurrencyText
      );
    },
    totalTransferPrice() {
      return (
        util.formatMoney(this.totalTransfer) +
        " " +
        this.$store.getters.SignCurrencyText
      );
    },
    totalExcursionPrice() {
      return (
        util.formatMoney(this.totalExcursion) +
        " " +
        this.$store.getters.SignCurrencyText
      );
    },
    totalPrice() {
      return (
        util.formatMoney(
          this.totalHotel + this.totalTransfer + this.totalExcursion
        ) +
        " " +
        this.$store.getters.SignCurrencyText
      );
    }
  },
  data: function () {
    return {
      hotelList: [],
      transferList: [],
      excursionList: [],
      totalHotel: 0,
      totalTransfer: 0,
      totalExcursion: 0,
      isSendDetail: []
    };
  },
  methods: {
    remove: function (val) {
      this.$emit("calculationRemove", val);
    },
    isHotel: function (calc) {
      return calc.basketType == BASKET_TYPE_HOTEL;
    },
    hotelBasket2Calculation: function (item, sequence) {
      let result = [];
      let sum = 0;
      let quantity = 0;

      let night = dateUtil.SubDateInDay(item.dateFrom, item.dateTo);
      let dt =
        dateUtil.FormatYYYYMMDDSepDot(item.dateFrom, ".") +
        " - " +
        dateUtil.FormatYYYYMMDDSepDot(item.dateTo, ".");
      let checkIn = dateUtil.FormatYYYYMMDDSepDot(item.dateFrom, "-");
      let checkOut = dateUtil.FormatYYYYMMDDSepDot(item.dateTo, "-");
      let extBronIsNetto = item.service.extBronIsNetto
        ? item.service.extBronIsNetto
        : "";

      sum = item.service.getPriceWitoutIncluded() * item.serviceCount;
      this.totalHotel += sum;

      result.push({
        basketGUID: item.guid,
        basketType: item.type,
        sequence: sequence,
        cityId: item.cityId,
        cityName: item.cityName,
        hotelId: item.hotel.id,
        hotelName: item.hotel.name,
        description: item.service.name,
        quantity: item.serviceCount,
        night: night,
        date: dt,
        price:
          util.formatMoney(sum) + " " + this.$store.getters.SignCurrencyText,
        isCalculated: true,
        detail: [],
        query: {
          checkIn: checkIn,
          checkOut: checkOut,
          serviceId: item.service.id,
          baseServiceId: "",
          source: item.service.source,
          touristCount: item.touristCount,
          hotelId: item.hotel.id,
          place: item.service.place,
          cityId: item.cityId,
          extBronIsNetto: extBronIsNetto,
          price: sum,
          quantity: item.serviceCount
        }
      });

      let sub = 1;
      item.service.additionalServices.forEach(srv => {
        let pr = srv.getPrice(item.service.priceIndex);

        if (srv.check || (srv.included && pr > 0)) {
          sum = pr * item.serviceCount;
          this.totalHotel += sum;
          quantity = this.getQuantity(
            srv.unitOfPayment,
            item.serviceCount,
            item.service.place + item.service.priceIndex
          );

          result.push({
            basketGUID: item.guid,
            basketType: item.type,
            sequence: sequence + "." + sub,
            cityId: item.cityId,
            cityName: item.cityName,
            hotelId: item.hotel.id,
            hotelName: item.hotel.name,
            description: srv.name,
            // quantity: srv.placeDependency ? (item.service.priceIndex + 1) * item.serviceCount : item.serviceCount,
            quantity: quantity,
            // night: night,
            night: this.getNight(srv.unitOfPayment, night),
            date: dt,
            price:
              util.formatMoney(sum) +
              " " +
              this.$store.getters.SignCurrencyText,
            isCalculated: srv.isCalculated,
            detail: [],
            query: {
              checkIn: checkIn,
              checkOut: checkOut,
              serviceId: srv.id,
              baseServiceId: item.service.id,
              source: item.service.source,
              touristCount: item.touristCount,
              hotelId: item.hotel.id,
              place: item.service.place,
              cityId: item.cityId,
              extBronIsNetto: extBronIsNetto,
              price: sum,
              quantity: quantity
            }
          });
          sub++;
        }
      });

      return result;
    },
    transferBasket2Calculation: function (item, sequence, onlySelected) {
      let result = [];
      let transferService = item.getOnlySelectedTransferService();

      if (
        (onlySelected && transferService) ||
        (!onlySelected && !transferService)
      ) {
        let sum = transferService
          ? transferService.price * item.serviceCount
          : 0;
        this.totalTransfer += sum;

        result.push({
          basketGUID: item.guid,
          basketType: item.type,
          sequence: sequence,
          cityId: item.cityId,
          cityName: item.cityName,
          hotelId: 0,
          hotelName: "",
          description: transferService
            ? transferService.name
            : item.transferName,
          quantity: item.serviceCount,
          night: 0,
          date: dateUtil.FormatYYYYMMDDSepDot(item.dateFrom, "."),
          price:
            util.formatMoney(sum) + " " + this.$store.getters.SignCurrencyText,
          detail: []
        });
      }

      return result;
    },
    trainBasket2Calculation: function (item, sequence) {
      let result = [];

      result.push({
        basketGUID: item.guid,
        basketType: item.type,
        sequence: sequence,
        cityId: item.cityId,
        cityName: item.cityName,
        hotelId: 0,
        hotelName: "",
        description: item.train.getTimetableName(),
        quantity: item.serviceCount,
        night: 0,
        date: dateUtil.FormatYYYYMMDDSepDot(item.dateFrom, "."),
        price: "",
        detail: []
      });

      return result;
    },
    excursionBasket2Calculation: function (item, sequence) {
      let result = [];

      if (item.excursion.length == 1) {
        let dt =
          item.dateFrom.getTime() == item.dateTo.getTime()
            ? dateUtil.FormatYYYYMMDDSepDot(item.dateFrom, ".")
            : dateUtil.FormatYYYYMMDDSepDot(item.dateFrom, ".") +
              " - " +
              dateUtil.FormatYYYYMMDDSepDot(item.dateTo, ".");
        let excursion = item.excursion[0];

        if (excursion.priceCalculate) {
          let sum = excursion.priceCalculate * item.touristCount;
          this.totalExcursion += sum;

          result.push({
            basketGUID: item.guid,
            basketType: item.type,
            sequence: sequence,
            cityId: item.cityId,
            cityName: item.cityName,
            hotelId: 0,
            hotelName: "",
            description: excursion.serviceName,
            quantity: item.touristCount,
            night: 0,
            date: dt,
            price:
              util.formatMoney(sum) +
              " " +
              this.$store.getters.SignCurrencyText,
            detail: []
          });
        }
      }

      return result;
    },
    getHotelList: function () {
      let result = [];
      let sq = 1;

      this.totalHotel = 0;

      this.basket.getItemCollection(BASKET_TYPE_HOTEL).forEach(item => {
        result = result.concat(this.hotelBasket2Calculation(item, sq));
        sq++;
      });

      return result;
    },
    getTransferList: function () {
      let result = [];
      let sq = 1;

      this.totalTransfer = 0;

      this.basket.getItemCollection(BASKET_TYPE_TRANSFER).forEach(item => {
        result = result.concat(this.transferBasket2Calculation(item, sq, true));
        sq++;
      });

      return result;
    },
    getExcursionList: function () {
      let result = [];
      let sq = 1;

      this.totalExcursion = 0;

      this.basket.getItemCollection(BASKET_TYPE_EXCURSION).forEach(item => {
        result = result.concat(this.excursionBasket2Calculation(item, sq));
        sq++;
      });

      return result;
    },
    clickDetail: function (item, index) {
      item.showDetail = !item.showDetail;
      if (item.showDetail && !item.detail.length && !this.isSendDetail[index]) {
        this.$emit("clickCalculationDetail", item);
        this.isSendDetail[index] = true;
      }
    },
    getQuantity: function (unitOfPayment, capacity, place) {
      let result = 0;

      if (
        unitOfPayment == UNIT_VOLUME_MBN ||
        unitOfPayment == UNIT_VOLUME_PLA ||
        unitOfPayment == UNIT_VOLUME_MAN ||
        unitOfPayment == UNIT_VOLUME_SRP ||
        unitOfPayment == UNIT_VOLUME_SRM
      ) {
        result = capacity * place;
      } else if (
        unitOfPayment == UNIT_VOLUME_NUM ||
        unitOfPayment == UNIT_VOLUME_DAY ||
        unitOfPayment == UNIT_VOLUME_NGT ||
        unitOfPayment == UNIT_VOLUME_SRV ||
        unitOfPayment == UNIT_VOLUME_HOR ||
        unitOfPayment == UNIT_VOLUME_SMH
      ) {
        result = capacity;
      }

      return result;
    },
    getNight: function (unitOfPayment, duration) {
      let result = duration;

      if (
        unitOfPayment == UNIT_VOLUME_MBN ||
        unitOfPayment == UNIT_VOLUME_PLA ||
        unitOfPayment == UNIT_VOLUME_MAN ||
        unitOfPayment == UNIT_VOLUME_NUM ||
        unitOfPayment == UNIT_VOLUME_DAY ||
        unitOfPayment == UNIT_VOLUME_NGT ||
        unitOfPayment == UNIT_VOLUME_HOR ||
        unitOfPayment == UNIT_VOLUME_SMH
      ) {
        result = duration;
      } else if (
        unitOfPayment == UNIT_VOLUME_SRV ||
        unitOfPayment == UNIT_VOLUME_SRP ||
        unitOfPayment == UNIT_VOLUME_SRM
      ) {
        result = 1;
      }

      return result;
    }
  },
  mounted() {
    this.hotelList = [];
    this.hotelList = this.getHotelList();

    this.transferList = [];
    this.transferList = this.getTransferList();

    this.excursionList = [];
    this.excursionList = this.getExcursionList();
  }
};
